import { SCOPES } from '../helpers/SCOPES';
import { getJwt, storeJwt } from '../store/store';
import { getProductUuid, getSiteUuid } from '../storage/last-braincube';
import BraincubeHttpError from '../errors/BraincubeHttpError';
/**
 * Refresh the JWT and store it in sessionStorage
 */
function refreshJwt(scope) {
    const url = new URL(`https://${window.BC_API_ENDPOINTS_CONF.sso}/sso-server/ws/session/refresh`);
    if (scope === SCOPES.PRODUCT) {
        const productUuid = getProductUuid();
        if (productUuid) {
            url.searchParams.set('productId', productUuid);
        }
    }
    else if (scope === SCOPES.SITE) {
        const siteUuid = getSiteUuid();
        if (siteUuid) {
            url.searchParams.set('siteUuid', siteUuid);
        }
    }
    return fetch(url.toString(), {
        credentials: 'include',
        method: 'POST',
    }).then((response) => {
        if (response.ok) {
            return response.text().then((jwt) => {
                if (jwt) {
                    storeJwt(jwt, scope);
                }
            });
        }
        throw new BraincubeHttpError(response);
    });
}
function addBearerToHeaders(scope, headers) {
    const jwt = getJwt(scope);
    if (jwt) {
        const authorizationHeaderKey = 'Authorization';
        const authorizationHeaderValue = `Bearer ${jwt}`;
        const authorizationHeader = new Headers({ [authorizationHeaderKey]: authorizationHeaderValue });
        let updatedHeaders = headers;
        // If there is no parameters, simply add the JWT header
        if (!updatedHeaders) {
            updatedHeaders = authorizationHeader;
            // If there are headers in the params, add them the JWT header
        }
        else {
            if (updatedHeaders.has(authorizationHeaderKey)) {
                updatedHeaders.delete(authorizationHeaderKey);
            }
            updatedHeaders.append(authorizationHeaderKey, authorizationHeaderValue);
        }
        return updatedHeaders;
    }
    return headers || new Headers();
}
export { refreshJwt, addBearerToHeaders };
